let environment: any = undefined
export const setEnvironment = (env: any) => environment = env;

const getEnvironmentValue = (keyPath: string, defaultValue?: any): any => {
    if (environment === undefined) throw new Error('Environment not set');
    const value = `${keyPath}.value`.split('.').reduce((prevProp: any, key: string) => prevProp?.[key], environment);
    if (value === undefined) {
        if (defaultValue !== undefined) return defaultValue;
        throw new Error('Failed to get value from environment and no default value provided');
    }

    return value;
}

export const getConfigValue = (keyPath: string, defaultValue?: any): any => {
    return getEnvironmentValue(`config.${keyPath}`, defaultValue);
}

export const getConfigNumber = (keyPath: string, defaultValue?: number): number => {
    const value = getConfigValue(keyPath, defaultValue);
    if (typeof value !== 'number') throw new Error(`Config value is not a number: type = ${typeof value}`);
    return value;
}

export const getConfigString = (keyPath: string, defaultValue?: string): string => {
    const value = getConfigValue(keyPath, defaultValue);
    if (typeof value !== 'string') throw new Error(`Config value is not a string: type = ${typeof value}`);
    return value;
}

export const getConfigBoolean = (keyPath: string, defaultValue?: boolean): boolean => {
    const value = getConfigValue(keyPath, defaultValue);
    if (typeof value !== 'boolean') throw new Error(`Config value is not a boolean: type = ${typeof value}`);
    return value;
}

export const getFlagValue = (keyPath: string): boolean => {
    const value = getEnvironmentValue(`flags.${keyPath}`);
    if (typeof value !== 'boolean') throw new Error(`Flag value is not a boolean: type = ${typeof value}`);
    return value;
}
